import styled from 'styled-components'
import Toasts from './Toasts'

export const StyledToasts = styled(Toasts)`
  position: fixed;
  top: 60px;
  right: 20px;
  width: 100%;
  z-index: 9999;
  pointer-events: none;
`
